<template>
	<div
		class="g-block-title-diamond g-block-title-padding"
		:class="{
			'g-block-title-diamond--edit': editable,
			'is-active': editable && active,
			'g-block-title-diamond--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-diamond__row">
			<div class="g-block-title-diamond__gems g-block-title-diamond__gems--left" aria-hidden="true">
				<span
					v-for="(_, index) in 3"
					:key="'left-' + index"
					class="g-block-title-diamond__gem"
					:style="getGemStyle(index, 'left')"
				></span>
			</div>

			<div class="g-block-title-diamond__text-wrap">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-diamond__text"
					fit-content
					:model-value="data.content"
					placeholder="请输入标题"
					@update:model-value="onContentUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-diamond__text"
					v-html="data.content || ''"
				></div>
			</div>

			<div class="g-block-title-diamond__gems g-block-title-diamond__gems--right" aria-hidden="true">
				<span
					v-for="(_, index) in 3"
					:key="'right-' + index"
					class="g-block-title-diamond__gem"
					:style="getGemStyle(index, 'right')"
				></span>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { getGemColors } from '../../../templates.js';

	export default {
		name: 'GBlockTitleDiamond',
		components: { RichTextEditable },
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select', 'update'],
		computed: {
			gemColor() {
				return this.data?.gemColor || '#285af9';
			},
		},
		methods: {
			getGemStyle(index, side = 'left') {
				const lightAmounts = side === 'left' ? [60, 30, 0] : [0, 30, 60];
				const amount = lightAmounts[index];
				const bgColor = this.lightenColor(this.gemColor, amount);
				const zIndex = side === 'left' ? index + 1 : 3 - index;
				return {
					background: bgColor,
					zIndex,
				};
			},
			lightenColor(hex, percent) {
				const num = parseInt(hex.replace('#', ''), 16);
				const amt = Math.round(2.55 * percent);
				const R = Math.min((num >> 16) + amt, 255);
				const G = Math.min((num >> 8 & 0x00FF) + amt, 255);
				const B = Math.min((num & 0x0000FF) + amt, 255);
				return '#' + (0x1000000 + R * 0x10000 + G * 0x100 + B).toString(16).slice(1);
			},
			onWrapClick(e) {
				if (!this.editable) return;
				e?.stopPropagation?.();
				this.$emit('select');
			},
			onContentUpdate(content) {
				this.$emit('update', { content });
			},
		},
	};
</script>

<style scoped lang="less">
	@title-color: #333333;
	@gem-size: 15px;
	@gem-visual-size: (@gem-size * 1.414213562);

	.g-block-title-diamond {
		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-title-diamond--h5 {
		.g-block-title-diamond__row {
			gap: 0.2rem;
		}

		.g-block-title-diamond__gem {
			width: 0.3rem;
			height: 0.3rem;

			& + & {
				margin-left: -0.1rem;
			}
		}

		.g-block-title-diamond__text-wrap {
			margin: 0 0.2rem;
		}

		.g-block-title-diamond__text {
			font-size: 0.36rem;
			line-height: 1.2;
		}
	}

	.g-block-title-diamond__row {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 10px;
		overflow: visible;
	}

	.g-block-title-diamond__gems {
		display: flex;
		align-items: center;
		flex-shrink: 0;
		align-self: center;
		padding: ((@gem-visual-size - @gem-size) / 2) 0;
	}

	.g-block-title-diamond__gem {
		position: relative;
		width: @gem-size;
		height: @gem-size;
		transform: rotate(45deg);
		flex-shrink: 0;

		& + & {
			margin-left: -5px;
		}
	}

	.g-block-title-diamond__text-wrap {
		display: flex;
		align-items: center;
		justify-content: center;
		min-width: 0;
		max-width: 100%;
		flex: 0 1 auto;
		align-self: center;
		margin: 0 10px;
		overflow: visible;
	}

	.g-block-title-diamond__text {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: auto;
		max-width: 100%;
		text-align: center;
		font-size: 18px;
		font-weight: 700;
		color: @title-color;
		line-height: 1.2;
		padding: 0;
		font-family: inherit;
		word-break: break-word;
		white-space: pre-wrap;
		overflow: visible;

		:deep(.g-rich-text-editable) {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: auto;
			max-width: 100%;
		}

		:deep(.g-rich-text-editable__content) {
			line-height: 1.2;
			min-height: unset;
			height: auto;
			padding: 0;
			text-align: center;
		}

		:deep(span),
		:deep(font),
		:deep(p),
		:deep(div) {
			line-height: inherit;
			margin: 0;
			padding: 0;
			vertical-align: middle;
		}
	}
</style>
